import React, { useEffect, useState } from 'react'
import { Placeholder } from '@sitecore-jss/sitecore-jss-react'
import SearchForm from './SearchForm/SearchForm'
import Results from './Results/Results'
import { postDataFetcher } from '../../dataFetcher'
import CONFIG_OBJECT from '../../config/config'
import App_Constants from '../../app-constants/App_Constants'
import RelatedItems from './RelatedItems/RelatedItems'
import Error from './Error/Error'
import Loader from './Loader/index'
import './Recipe-SearchResult.css'
import componentDisplayExtension from '../../commonUtils/ComponentDisplayExtension';
import { withTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

const defaultitemperpage = 10

const RecipeSearchResult = (props) => {
    const [apidata, setApidata] = useState({
        data: '',
        totalCount: 1,
        itemsPerPage: sessionStorage.getItem('pageperitem') ? sessionStorage.getItem('pageperitem') : 10,
        numberOfPages: 1,
        currentPage: 1,
        result: [],
        relatedItems: [],
        relatedItemsBlk: false,
        filtergroup: ''
    })
    const [searchfieldText, setSearchfieldtext] = useState({
        text: sessionStorage.getItem('searchRecipeText') || '',
        resultdata: ''
    })

    const [filterData, setFilterData] = useState({
        groupdata: null
    })
    const [loader, setLoader] = useState(true)
    const [categorytext, setCategorytext] = useState('')
    const [pageSize, setPageSize] = useState()
    const [removeItem, setRemoveItem] = useState()


    useEffect(() => {

        setLoader(true)
        setPageSize(props.fields.pageSize && props.fields.pageSize)
        let data = {
            searchKeyword: sessionStorage.getItem('searchRecipeText') || searchfieldText.text,
            PageNumber: apidata.currentPage,
            filterIDs: filterData.groupdata ? JSON.stringify(filterData.groupdata) : null,
            itemsPerPage: sessionStorage.getItem('pageperitem') ? sessionStorage.getItem('pageperitem') : apidata.itemsPerPage
        }
        postDataFetcher(`${CONFIG_OBJECT.RF_REST_URL}${App_Constants.SC_API_KEY}`, data)
            .then(res => {
                if (res.data.HasError) {
                    setLoader(false)
                    console.log(res.data.HasError)
                } else {
                    if (res.data.Data.pagination !== null) {
                        setLoader(false)
                        setApidata({
                            data: res.data.Data,
                            totalCount: res.data.Data.pagination.totalCount,
                            itemsPerPage: res.data.Data.pagination.itemsPerPage,
                            numberOfPages: res.data.Data.pagination.numberOfPages,
                            currentPage: res.data.Data.pagination.currentPage,
                            result: res.data.Data.recipes,
                            relatedItems: res.data.Data.relatedItems,
                            relatedItemsBlk: false,
                            filtergroup: res.data.Data.filters
                        })
                    } else {
                        setLoader(false)
                        setApidata({
                            data: '',
                            totalCount: 1,
                            itemsPerPage: defaultitemperpage,
                            numberOfPages: 1,
                            currentPage: 1,
                            result: null,
                            relatedItems: res.data.Data.relatedItems,
                            relatedItemsBlk: true,
                            filtergroup: null
                        })
                    }
                }
            }, err => {
                setLoader(false)
                console.log(err);
            });
    }, [apidata.currentPage, searchfieldText.text, apidata.itemsPerPage, filterData.groupdata])

    const paginate = (pagenumber) => {
        setApidata({
            ...apidata,
            currentPage: pagenumber
        })
    }

    const getSearchFieldData = (searchtext) => {
        sessionStorage.setItem('searchRecipeText', searchtext)
        setCategorytext('')
        setSearchfieldtext({
            text: searchtext
        })
        setApidata({
            ...apidata,
            itemsPerPage: defaultitemperpage,
            currentPage: 1,
        })
    }

    const getCategory = (category) => {
        setCategorytext(category)
    }

    const itemsperpage = (itemcount) => {
        setApidata({
            ...apidata,
            itemsPerPage: itemcount,
            currentPage: 1
        })
    }

    const getFilterData = (data) => {
        setFilterData({
            groupdata: data
        })
    }

  const clearallfilter = (data) => {
    sessionStorage.setItem('searchRecipeText', '')
    setRemoveItem(data)
  }

    const clearfilteritem = (itemtoremove) => {
        setRemoveItem(itemtoremove)
    }



    //IFRAME: Code to check displaying based on querystring
    if (!componentDisplayExtension.isDisplay(props)) {
        return (<></>)
    }
    //---------------------------------------------

    return (
        <div className="container">
            <div className="ss-landing">
                <Placeholder
                    name="social-share"
                    rendering={props.rendering}
                    itemid={props.itemid}
                />
            </div>
            {!isMobile && <p className="formintro" dangerouslySetInnerHTML={{ __html: props.fields.description.value }} />}

            <SearchForm
                getSearchFieldData={getSearchFieldData}
                apidata={apidata}
                ritems={apidata.relatedItems}
                categorytext={categorytext !== '' && categorytext}
                filtergrouplabel={props.fields.filterGroup}
                filterData={getFilterData}
                removeitem={removeItem}
            />
            {
                loader ? <Loader /> :
                    apidata.result && (apidata.result !== null && apidata.result.length > 0) ?
                        <>
                            <Results
                                resultData={apidata.result}
                                paginate={paginate}
                                paginatedata={apidata}
                                pageSize={pageSize}
                                itemsperpage={itemsperpage}
                                searchtext={searchfieldText.text}
                                filters={apidata.filtergroup}
                                clearallfilter={clearallfilter}
                                clearfilteritem={clearfilteritem}
                            />
                        </>
                        :
                        apidata.relatedItems.length > 0 &&
                        <div>
                            <Error />
                            <RelatedItems
                                relateditems={apidata.relatedItems}
                                category={getCategory}
                            />
                        </div>
            }
        </div>
    )
};

export default withTranslation()(RecipeSearchResult);
